module.exports = __webpack_public_path__ + "img/watch.8a568f54.svg";